import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps, mapProps, lifecycle } from 'recompose';
import { List } from 'immutable';
import round from 'lodash/round';

import summarizeTimeplanUnits from '../../../../app/components/Form/Timeplan/summarizeTimeplanUnits';
import { CustomerRecord } from '../../../../app/entities/records';
import { withCustomer } from '../../../../app/containers';
import { withFetch } from '../../../../app/entities/Entity/containers';
import { Endpoints } from '../../../../app/lib/LeanLinkService';

function CustomerSummary({ customer, summarizedTimeplanUnits }) {
  return (
    <table className="table">
      <tbody>
        {summarizedTimeplanUnits.map(summary => (
          <tr key={summary.id}>
            <td>{customer.get('name')}, {summary.name}</td>
            <td>{round(summary.minutes / 60, 2)} h</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

CustomerSummary.propTypes = {
  customer: PropTypes.instanceOf(CustomerRecord).isRequired,
  summarizedTimeplanUnits: PropTypes.instanceOf(List).isRequired,
};

export default compose(
  withProps(({ timeplanUnits, customerId }) => ({
    timeplanUnits: timeplanUnits.filter(tpu => tpu.get('customer') === customerId),
  })),
  withFetch(),
  lifecycle(({
    componentWillMount() {
      const url = Endpoints.public.resourceApi.absentReasons();
      this.props.fetch({ url }).then((data) => {
        const absentReasons = data.result.items.reduce((acc, o) => (
          acc.push(o.get('id').toJS())
        ), new List());
        this.setState({ absentReasons });
      });
      this.setState({ absentReasons: new List() });
    },
  })),
  mapProps(({ workTypes, timeplanUnits, customerId, absentReasons }) => ({
    customerId,
    summarizedTimeplanUnits: summarizeTimeplanUnits(
      workTypes,
      timeplanUnits.toJS(),
      timeplanUnits.toJS(),
      absentReasons,
    ),
  })),
  mapProps(({ summarizedTimeplanUnits, ...props }) => ({
    ...props,
    summarizedTimeplanUnits: summarizedTimeplanUnits.reduce((newSummaries, summary) => {
      const index = newSummaries.findIndex(({ name }) => name === summary.name);
      if (index === -1) {
        return newSummaries.push(summary);
      }
      const b = newSummaries.get(index);
      return newSummaries.set(
        index,
        {
          id: b.id,
          name: b.name,
          minutes: b.minutes + summary.minutes,
          diffMinutes: b.diffMinutes + summary.diffMinutes,
        },
      );
    }, new List()),
  })),
  withCustomer,
)(CustomerSummary);
